import { createSlice } from '@reduxjs/toolkit';
import { IMobileTopMenuData } from '../interfaces';
import { getMobileMenuData } from '../domain/mobile-top-menu-provider';

interface IState {
    data?: IMobileTopMenuData;
    isOpened: boolean;
    selectedTabId?: string|null;
    isLoading: boolean;
    isLoggedIn: boolean;
    userName: string;
}

const data = getMobileMenuData();

/**
 * initial state
 */
const initialState: IState = {
    data,
    isOpened: false,
    selectedTabId: data?.topMenu?.length > 0 ? data?.topMenu[0].id : null,
    isLoading: false,
    isLoggedIn: false,
    userName: '',
};

const rootSlice = createSlice({
    name: 'root',
    initialState,
    reducers: {

        main(state, action) {
            return {
                ...state,
                ...action.payload,
            }
        },

        toggle(state, action) {
            const newState = {
                ...state,
                ...action.payload,
            };

            if(newState.isOpened){
                newState.selectedTabId = data?.topMenu?.length > 0 ? data?.topMenu[0].id : null;
            }

            return newState;
        }
    }
});

export default rootSlice;